import { Link } from "react-router-dom";

export default function NavLinks({
  location,
  isMobile = false,
  onLinkClick,
}) {
  const categories = [
    { name: "Home", path: "/home" },
    { name: "About Us", path: "/aboutus" },
    { name: "Contact", path: "/contact" },
  ];

  return (
    <nav
      className={`${
        isMobile
          ? "flex flex-col gap-4"
          : "flex gap-4 h-full"
      } text-[#3B2A1F] font-medium`}
    >
      {categories.map((cat) => {
        const isActive =
          (cat.path === "/women" &&
            (location.pathname === "/" ||
              location.pathname === "/women")) ||
          location.pathname === cat.path;

        return (
          <Link
            key={cat.name}
            to={cat.path}
            onClick={() => {
              if (onLinkClick) onLinkClick();
            }}
            className={`${
              isMobile
                ? `text-lg transition-colors duration-200 ${
                    isActive
                      ? "text-[#0F5C5C] font-semibold"
                      : "text-[#3B2A1F] hover:text-[#B88746]"
                  }`
                : `flex items-center transition-all duration-200 ${
                    isActive
                      ? "text-[#0F5C5C] -translate-y-2 font-semibold"
                      : "text-[#3B2A1F] hover:text-[#0F5C5C]"
                  }`
            }`}
          >
            {cat.name}
          </Link>
        );
      })}
    </nav>
  );
}